import { call, put, takeEvery } from "redux-saga/effects";
import { eConnectionActionTypeIds, IConnectionActionTypes } from "../action-types/IConnectionActionTypes";
import { rootActions } from "../actions/rootActions";
import { connectionApi } from "../../api/connectionApi";
import { IBaseRespone } from "../../model/respone/IBaseRespone";
import { IConnection } from "../../model/respone/IConnection";

const mainAction = rootActions.connection;
export function* connectionSaga(): any {
    yield takeEvery(eConnectionActionTypeIds.GENERATE_START, generateWorker)

}

function* generateWorker(action: IConnectionActionTypes): any {
    const connection: IConnection = (action.payload as IConnection);
    const res: IBaseRespone = yield call(connectionApi.generate, action.payload as IConnection)
    if (res.is_success) {
        yield put(mainAction.GENERATE_SUCCESS({
            connection,
            data: res.data
        }))
    } else {
        yield put(mainAction.GENERATE_ERROR({
            connection,
            data: res.message ?? "Có lỗi"
        }))
    }
}
